module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#share",
      toString: function () {
        return this.url;
      }
    }